import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from "framer-motion"
import { GiHotMeal } from 'react-icons/gi'
import { BsSearchHeart } from "react-icons/bs";
import { IoCloseOutline } from "react-icons/io5";

import tasty from "../images/tasty3.svg"
import promo from '../images/promo.jpeg'

const Menu = ({ isEng, isFood, closePromoBanner, info, products, selectedCat, setSelectedCat, categories, searchStarted, searchFoodObject, setSearchFoodObjectHandler, handleSearch }) => {

    let information = {}
    if (info) {
        information = info[0]
    }
    let lunchMenu = {}
    if (categories) {
    
        if(categories.length > 0){
            lunchMenu = categories[0]
        }
       
    }

    const [hasLunchToday, setHasLunchTOday] = useState(false)
    const [hasSpecialMenuToday, setHasSpecialMenuTOday] = useState(false)
    const [hasPromo, setHasPromo] = useState(true)


    function filterProducts(prods) {
        if (searchFoodObject !== '') {
          

            let produkts = prods.filter((a) => {
              
                return (
                    a.title.toLowerCase().includes(searchFoodObject.toLowerCase())
                )
            })
            let bodyProdukts = prods.filter((a) => {
                return (!a.title.toLowerCase().includes(searchFoodObject.toLowerCase()) && (a.body !== null && a.body.toLowerCase().includes(searchFoodObject.toLowerCase())));
            })
            produkts = [...produkts, ...bodyProdukts]
            produkts.sort((a, b) => {
                return a.title.toLowerCase().includes(searchFoodObject.toLowerCase()) > !a.title.toLowerCase().includes(searchFoodObject.toLowerCase()) ? -1 : 1
            })
            return produkts;

        } else {
            let filteredData = []
            for (let prod of prods) {
                if (prod.categories?.title === selectedCat) {
                    if (prod.categories.importance === -1) {

                        let date = new Date(prod.publishedAt)
                        let year = date.getFullYear()
                        let month = date.getMonth() + 1
                        let day = date.getDate()
                        date = year + '.' + month + '.' + day
                        let currentDate = new Date()
                        let yearNow = currentDate.getFullYear()
                        let monthNow = currentDate.getMonth() + 1
                        let dayNow = currentDate.getDate()
                        let hour = currentDate.getHours()
                        currentDate = yearNow + '.' + monthNow + '.' + dayNow

                        if (date == currentDate) {
                            prod.publishedAt = new Date(prod.publishedAt)




                            filteredData.push(prod)

                        }
                        // console.log(`${year}.${month}.${day}`)
                        // console.log(currentDate)

                    } else {

                        prod.publishedAt = new Date(prod.publishedAt)
                        filteredData.push(prod)
                    }

                }
            }

            let sortedData = filteredData.sort((a, b) => b.publishedAt - a.publishedAt)

            return sortedData
        }

    }
    let filteredProducts = []
    if (products !== null) {
        filteredProducts = filterProducts(products)

    }
    useEffect(() => {

        if (products !== null) {
            for (let eachProd of products) {
                // console.log(eachProd)
                if (eachProd.categories?.importance === -1) {
                    let date = new Date(eachProd.publishedAt)
                    let year = date.getFullYear()
                    let month = date.getMonth() + 1
                    let day = date.getDate()
                    date = year + '.' + month + '.' + day
                    let currentDate = new Date()
                    let yearNow = currentDate.getFullYear()
                    let monthNow = currentDate.getMonth() + 1
                    let dayNow = currentDate.getDate()
                    currentDate = yearNow + '.' + monthNow + '.' + dayNow
                    if (date == currentDate) {
                        setHasLunchTOday(true);
                    }


                }
                if (eachProd.categories?.importance === 9999) {
                    setHasSpecialMenuTOday(true)
                }
            }
        }

    }, [products])


    return (
        <>
       
            {categories && categories.length > 0  && <AnimatePresence>
                {isFood && <motion.div
                    initial={{ x: 300, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: -300, opacity: 0 }}
                    className='w-full m-auto mb-[80px] text-center '>

                    {/* Category picker */}
                    <div className='w-full flex flex-col flex-wrap gap-y-[0.3rem] -mt-[5px] justify-center  text-md  font-bold'>

                        {/* <div className='w-full flex  justify-center'>
                                <h1 className=' sm:text-3xl self-center text-2xl font-bold'>{!isEng ? "Изберете категория:" :
                                    "Category:"}
                                </h1>
                            </div>     */}


                        <div className={`flex flex-row  flex-wrap justify-around ${hasLunchToday ? '' : 'mt-3'}`}>
                            {/* ALL AND SPECIAL CATEGORY */}
                            <div className={`w-full flex justify-center z-10 m-auto mx-2 font-categories ${hasLunchToday ? 'flex' : 'hidden'}`}>

                                <div onClick={() => { setSelectedCat(categories[0].title) }}
                                    className={`cursor-pointer self-center ml-1 mr-1 mt-2 justify-center w-3/6 h-[30px] mb-[5px] text-center md:justify-center  md:pl-10  rounded-md flex flex-row items-center  
                                    ${selectedCat === (categories ? categories[0].title : "b") ? 'bg-red text-mainOne' : ' bg-mainOne text-mainTwo'}  
                                    ${hasLunchToday ? 'flex' : 'invisible'}
                                    italic p-1   text-md `}>
                                    <p className={selectedCat === (categories ? categories[0].title : "b") ? ` text-mainOne ` : `text-red`}>
                                        {!isEng ? categories && categories[0].title : "Lunch menu!"}</p>
                                    <GiHotMeal className={`${selectedCat === (categories ? categories[0]?.title : "b") ? ` text-mainOne` : 'text-red '} ml-2`} size={25} />
                                </div>
                            </div>
                            {/*CATEGORIES MAP ARRAY */}
                            {searchStarted &&
                                <AnimatePresence>
                                    <motion.div
                                        className="flex flex-row"
                                        initial={{ x: -300, opacity: 0 }}
                                        animate={{ x: 0, opacity: 1 }}
                                        exit={{ x: 300, opacity: 0 }}>

                                        <div classname=" flex-row w-3/4 flex-nowrap">
                                            <label for="Search" class="sr-only"> Search </label>

                                            <input
                                                type="text"
                                                id="Search"
                                                placeholder="Хапва ми се..."
                                                value={searchFoodObject}
                                                onChange={(e) => {
                                                    setSearchFoodObjectHandler(e.target.value)
                                                }}

                                                class="pl-2 w-full rounded-md border-gray-200 py-2.5 pe-10 shadow-sm sm:text-sm"
                                            />

                                            <span class="absolute inset-y-0 end-0 grid w-10 place-content-center">
                                                <button type="button" class="text-gray-600 hover:text-gray-700">
                                                    <span class="sr-only">Search</span>

                                                    <path
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                                                    />

                                                </button>

                                            </span>

                                        </div>
                                        <motion.div
                                            className='m-auto z-[100]'
                                            whileTap={{ rotate: 360 }}
                                            transition={{ type: "spring" }}

                                        >
                                            <IoCloseOutline
                                                onClick={(е) => {
                                                    setSearchFoodObjectHandler('')
                                                    handleSearch()

                                                }}
                                                size={35} />
                                        </motion.div>
                                    </motion.div>

                                </AnimatePresence>}
                            {!searchStarted && categories && categories.map((category, i) =>
                                <AnimatePresence>
                                    <motion.div
                                        initial={{ x: -300, opacity: 0 }}
                                        animate={{ x: 0, opacity: 1 }}
                                        exit={{ x: 300, opacity: 0 }}

                                        onClick={() => {
                                            closePromoBanner()
                                            setSelectedCat(category.title)
                                        }}
                                        key={category.importance}
                                        className={`cursor-pointer w-1/5 rounded-md mt-1 z-10 font-categories  flex items-center justify-center leading-[1rem]  text-sm h-[40px]
                                    ${category.importance < 0 && 'hidden'}
                                     ${category.importance > 9998 && 'hidden'}
                                    ${i > 0 && "ml-[1px]"}
                                    ${selectedCat === category.title
                                                ? ' bg-mainThree text-mainOne ' : 'bg-mainOne text-mainTwo'}  text-center italic p-1 `}>
                                        <p>{category.title}</p>
                                    </motion.div>

                                </AnimatePresence>
                            )}
                            {/* SPECIAL MENU 2 CATEGORY */}
                           
                            {hasSpecialMenuToday &&
                                <div className={`w-full flex justify-center m-auto mx-2 font-categories`}>

                                    <div onClick={() => { setSelectedCat(categories[categories.length - 1].title) }}
                                        className={`cursor-pointer self-center ml-1 mr-1 mt-2 justify-center w-3/6 h-[30px] mb-[5px] text-center md:justify-center  md:pl-10  rounded-md flex flex-row items-center  
                             ${selectedCat === (categories ? categories[categories.length - 1].title : "b") ? 'bg-red text-mainOne' : ' bg-mainOne text-mainTwo'}  
   
                                                                 italic p-1   text-md `}>
                                        <p className={selectedCat === (categories ? categories[categories.length - 1].title : "b") ? ` text-mainOne ` : `text-red`}>
                                            {categories && categories[categories.length - 1].title}</p>

                                    </div>
                                </div>}

                        </div>


                    </div>
                    {/* SHOWCASE */}

                    <div className='w-11/12 m-auto mt-2 sm:flex sm:flex-wrap sm:flex-row '>
                        {/* EACH PRODUCT */}
                        {console.log(selectedCat)}
                        {selectedCat === lunchMenu.title ? <div>
                            <p className='text-2xl m-1'>Продуктите от тази категория се предлагат в часови диапазон:
                                {information.lunchHours}
                            </p></div> : <div></div>}
                        {!searchStarted && filteredProducts.length === 0 &&
                            <p className='text-mainThree text-xl italic w-1/2 m-auto mt-10'>
                                {!isEng ? "За съжаление нямаме продукти от тази категория в момента." : "We are loading..."}
                            </p>}
                        {searchStarted && filteredProducts.length === 0 &&
                            <p className='text-mainThree text-xl italic w-1/2 m-auto mt-10'>
                                {!isEng ? "Нямаме продукти, които отговарят на това търсене ..." : "We dont have any products meeting this criteria..."}
                            </p>}
                        {filteredProducts && filteredProducts.map((product, i) =>

                            <div key={product?.slug?.current}
                                className={`flex flex-col h-[450px]  w-full sm:w-1/2  lg:w-1/3 
                        ${(product.categories?.importance === -1 && selectedCat !== categories[0].title) && 'hidden'}`}>
                                <div className='border  border-black border-b-0 h-[320px] border-opacity-60 text-[#2a5d80] overflow-hidden'>
                                    <div className='h-[320px] w-full overflow-hidden  border-black relative'>

                                        <motion.img
                                            initial={{ scale: 0.7 }}
                                            whileInView={{ scale: 1 }}
                                            whileTap={{ scale: 1.5 }}
                                            whileHover={{ scale: 1.1 }}
                                            transition={{ duration: 0.3 }}
                                            className=' object-contain  w-full p-2 h-full' src={(product.mainImage?.asset?.url
                                                && product.mainImage?.asset?.url + '?auto=format&w=1200') || tasty}></motion.img>
                                        {!product.instock && <div className=''>
                                            <p className='absolute -rotate-12 rounded-lg font-extrabold top-6 ml-3 text-4xl w-2/3  z-100 border-2 text-red border-red'>Продуктът е изчерпан</p>
                                        </div>}
                                    </div>
                                </div>
                                <div className='border  border-t-0 flex  border-black border-opacity-60 text-mainThree overflow-hidden'>
                                    <div className='z- w-full p-[1px] self-start h-[162px]  text-md flex justify-around items-center'>
                                        <div className='w-9/12 flex flex-col'>
                                            <h1 className='text-base font-bold font-title leading-[1rem]'>{product.title} - {product.weight &&
                                                ` ${product.weight}`}{!isEng ? "гр." : "gr."}</h1>
                                            <div className='prose p-2 flex flex-col italic  items-center  text-base'>
                                                {/* <p className='text-mainThree '>{!isEng ? "Описание:" : "Description:"}</p> */}
                                                <div className='mb-4 leading-[1rem] font-description'>
                                                    <p>{!isEng ? product.body : product.body_eng}</p>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='h-[60px] w-[60px] mr-2 border border-[#2a5d80] rounded-full bg-mainOne flex flex-col justify-center items-center'>
                                            <p className='font-price text-mainTwo'>{product.price}{!isEng ? "лв." : "bgn."}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='mt-6 font-end-of-category italic pb-4 text-mainTwo'>
                        {filteredProducts.length !== 0
                            &&
                            <h1>{!isEng ? "Достигнахте до края на тази категория." : "You reached the end of this category"}</h1>}
                    </div>


                </motion.div>}
            </AnimatePresence>}
        </>
    )
}

export default Menu